module.exports = __webpack_public_path__ + "img/30-02.11690d15.png";